import { Helmet } from 'react-helmet-async';

import { MyTasksView } from 'src/sections/my-tasks/view';

// No permission gate — every logged-in user has their own tasks list
// (admins see every low/out-of-stock item, everyone else only their own
// Reorder Settings assignments; the branch lives server-side).
export default function MyTasksPage() {
  return (
    <>
      <Helmet>
        <title> My Tasks</title>
      </Helmet>

      <MyTasksView />
    </>
  );
}
